import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "thirdPartyPhoneAccountConfig" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { modalConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { getListData } from '@/service/main/system'
import { useStore } from '@/store'
import { ref, reactive, nextTick } from 'vue'
import PageModal from '@/components/PageModal.vue'
import { usePageModal } from '@/hooks/usePageModal'
import { initEmptyParam } from '@/hooks/useInitParam'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'ThirdPartyPhoneAccountConfig',
  setup(__props) {

initEmptyParam()
const store = useStore()

let corpListData: any[] = []
const modalUrl = ref('')

const getCompanyList = async () => {
  let corpData = await getListData('/main/enterpriseWechat/config/listAll', {})
  corpListData = corpData

  const corpItem = searchFormConfig.formItems?.find((item) => item.field === 'corpId')
  if (corpItem) {
    corpItem.options = corpData.map((item: any) => {
      return { title: item.name, value: item.corPid }
    })
  }

  const modalCorpItem = modalConfig.formItems?.find((item) => item.field === 'corpId')
  if (modalCorpItem) {
    modalCorpItem.options = corpData.map((item: any) => {
      return { title: item.name, value: item.corPid }
    })
  }
}

getCompanyList()

const queryParam = {
  pageNo: 1,
  pageSize: 10
}

store.commit('system/changeQueyryInfo', queryParam)

const resetCb = () => {
  return { ...queryParam }
}

const [
  pageContentRef,
  handleResetClick,
  _,
  handleDownBtnClick
] = usePageSearch(resetCb)

// 自定义搜索逻辑：解决日期参数转换及重置失效问题
const handleSearchClick = (formdata: any) => {
  // 1. 浅拷贝 formdata，防止直接修改导致页面表单状态（回显）异常
  const params = { ...formdata }

  // 2. 转换开始日期格式
  if (params.startDateRange && params.startDateRange.length === 2) {
    params.startDateBegin = params.startDateRange[0]
    params.startDateEnd = params.startDateRange[1]
    // 在副本中删除 Range 字段，避免传给后端多余参数，同时保留原 formdata 中的值用于页面回显
    delete params.startDateRange
  }

  // 3. 转换结束日期格式
  if (params.endDateRange && params.endDateRange.length === 2) {
    params.endDateBegin = params.endDateRange[0]
    params.endDateEnd = params.endDateRange[1]
    delete params.endDateRange
  }

  // 4. 发起请求
  pageContentRef.value?.getPageData(params)
}

const modalTitle = ref('新增三方电话资源账号配置')

const newCb = () => {
  modalTitle.value = '新增三方电话资源账号配置'
  modalUrl.value = '/main/thirdPartyPhoneAccountConfig/insert'
}

const editCb = (item: any) => {
  modalTitle.value = '编辑三方电话资源账号配置'
  modalUrl.value = '/main/thirdPartyPhoneAccountConfig/update'
}

const otherInfo = reactive({})

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)

const handleSortChange = (value: any) => {
  let orderBy = value.prop
  if (orderBy) {
    orderBy = orderBy.replace('Desc', '')
  }
  store.commit('system/changeOrderInfo', {
    orderBy: orderBy,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const handleCorpChange = (field: any, value: any, formData: any) => {
  if (field.field === 'corpId' && value) {
    const selectedCorp = corpListData.find((item: any) => item.corPid === value)
    if (selectedCorp) {
      nextTick(() => {
        formData.corpName = selectedCorp.name
      })
    }
  }
}

const handleSubmit = () => {
  const formData = (pageModalRef.value as any).formData
  const isEdit = Object.keys(defaultInfo.value).length > 0 && !(pageModalRef.value as any).isAdd

  if (isEdit) {
    const editId = defaultInfo.value.id
    if (editId !== undefined && editId !== null) {
      formData.id = editId
    } else {
      ElMessage.warning('缺少ID参数，请刷新页面重试')
      return false
    }
  }

  if (!formData.corpId) {
    ElMessage.warning('请选择主体')
    return false
  }

  if (!formData.corpName) {
    const selectedCorp = corpListData.find((item: any) => item.corPid === formData.corpId)
    if (selectedCorp) {
      formData.corpName = selectedCorp.name
    }
  }

  if (!formData.thirdParty) {
    ElMessage.warning('请选择所属第三方')
    return false
  }

  if (!formData.workAccount) {
    ElMessage.warning('请输入工作账号')
    return false
  }
  if (!formData.startDate) {
    ElMessage.warning('请选择承接资源开始日期')
    return false
  }
  if (!formData.endDate) {
    ElMessage.warning('请选择承接资源结束日期')
    return false
  }
  return true
}

// 定义筛选规则
const filterRules = [
  '目前配置的账号只算半马星的数据',
]


return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      class: "custom-search-bar",
      searchFormConfig: _unref(searchFormConfig),
      labelWidth: "130px",
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: handleSearchClick
    }, null, 8, ["searchFormConfig", "onResetBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "thirdPartyPhoneAccountConfig",
      pageUrl: "/main/thirdPartyPhoneAccountConfig/queryByCondition",
      delUrl: "/main/thirdPartyPhoneAccountConfig",
      onEditBtnClick: _unref(handleEditData),
      onNewBtnClick: _unref(handleNewData),
      onSortChange: handleSortChange,
      filterRules: filterRules
    }, null, 8, ["contentTableConfig", "onEditBtnClick", "onNewBtnClick"]),
    _createVNode(PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "thirdPartyPhoneAccountConfig",
      url: modalUrl.value,
      otherInfo: otherInfo,
      validOtherInfo: handleSubmit,
      onChange: handleCorpChange
    }, null, 8, ["defaultInfo", "modalConfig", "title", "url", "otherInfo"])
  ]))
}
}

})